import { ChipOrderStatus } from 'modules/order/common/components';
import { OrdersListItem } from 'modules/order/orders/types';

export const renderOrderStatus = (item: Pick<OrdersListItem, 'status'>) => (
  <ChipOrderStatus size="m" status={item.status} uppercase={false} />
);
